import React, { useState, useEffect } from 'react';
/* import { useNavigate } from 'react-router-dom'; */
import EscalaPNG from '../images/escala de profissionais.png';
import PaineisPNG from '../images/paineis.png';
import AtividadesPNG from '../images/atividades.png';
import CalculoPNG from '../images/calculo.png';
import ContatosPNG from '../images/contatos.png';
import EventosPNG from '../images/eventos.png';
import AdcionarPNG from '../images/adcionarEvento.png';
import CalendarioPNG from '../images/calendario interno.png';
import Monitoramento from '../images/monitoramento.png';
import Cookies from 'js-cookie';
/* JSON.parse(Cookies.get('user')); */

function ICards() {
	/* const navigate = useNavigate(); */
	const [visibleCards, setVisibleCards] = useState([]);

	let user;
	if (Cookies.get('user')) {
		user = JSON.parse(Cookies.get('user'));
	}

	// Função para determinar os cards visíveis com base nas condições
	const determineVisibleCards = () => {
		const allCards = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
		let filteredCards = allCards;

		// Condição 1: Usuário é gestor

		if (user?.nome === 'Daniel Lopes da Mata') {
			filteredCards = allCards.filter(
				(card) => ![0, 2, 3, 4, 6, 7].includes(card)
			);
		}

		if (user?.unidade === 'subhue') {
			let array = [0, 2, 3, 4, 6, 7];
			filteredCards = allCards.filter((card) => !array.includes(card)); // Remove Agenda Interna SUBHUE
		}

		if (user?.cargo === 'gestor') {
			filteredCards = allCards.filter(
				(card) => ![3, 4, 5, 7, 8, 9].includes(card)
			); // Remove Agenda Interna SUBHUE
		}
		if (user?.cargo === 'usuario' && user?.unidade !== 'subhue') {
			let array = [2, 3, 4, 5, 6, 7, 8, 9];
			!user?.permissao.includes('Escala') && array.push(0);
			if (
				!user?.permissao.includes('Classificadores') &&
				!user?.permissao.includes('Investigadores')
			) {
				array.push(10);
			}
			filteredCards = allCards.filter((card) => !array.includes(card)); // Remove Agenda Interna SUBHUE
		}
		if (user?.cargo.includes('desenvolvedor')) {
			filteredCards = allCards.filter(
				(card) => ![3, 4, 7].includes(card)
			);
		}

		setVisibleCards(filteredCards);
	};

	useEffect(() => {
		determineVisibleCards();
	}, []);

	const getSVG = (index) => {
		switch (index) {
			case 0:
				return (
					<img
						alt='Escala de Profissionais'
						src={EscalaPNG}
					/>
				);
			case 1:
				return (
					<img
						alt='Painéis de Monitoramento'
						src={PaineisPNG}
					/>
				);
			case 2:
				return (
					<svg
						width='180'
						height='auto'
						viewBox='0 0 118 70'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M2.31134 47.6222V0.855659H11.8841V18.7828H32.5897V0.855659H42.1624V47.6222H32.5897V27.4276H11.8841V47.6222H2.31134ZM50.1674 24.2389C49.9546 10.8466 61.5128 -0.278083 75.1275 0.00529706C83.9912 0.00529706 91.5784 4.32767 95.7621 11.6261L88.5293 16.7279C85.1965 11.4844 80.7293 8.86264 75.1275 8.86264C66.4056 8.86264 60.0237 15.3816 60.0237 24.3098C60.0237 33.238 66.4056 39.6152 75.1275 39.6152C80.7293 39.6152 85.1965 36.9935 88.5293 31.7499L95.7621 36.8518C91.7202 44.1502 84.062 48.4726 75.0565 48.4726C61.371 48.7559 49.8838 37.6311 50.1674 24.2389ZM103.897 47.6222V0.855659H113.47V47.6222H103.897Z'
							fill='white'
						/>
						<path
							d='M0.5 68.2024V61.9912H1.49827V64.4663H4.62492V61.9912H5.6232V68.2024H4.62492V65.3604H1.49827V68.2024H0.5ZM7.08344 68.2024V63.5817H8.07226V68.2024H7.08344ZM6.90451 61.8595C6.90451 61.4925 7.20588 61.2008 7.58257 61.2008C7.94987 61.2008 8.25125 61.4925 8.25125 61.8595C8.25125 62.2266 7.94987 62.5089 7.58257 62.5089C7.20588 62.5089 6.90451 62.2266 6.90451 61.8595ZM9.06902 67.412L9.63408 66.7908C10.039 67.2143 10.444 67.4496 10.9337 67.4496C11.3576 67.4496 11.6777 67.2708 11.6777 66.932C11.6777 66.659 11.4799 66.5462 11.0279 66.3579L10.557 66.1603C9.73767 65.8215 9.3516 65.4639 9.3516 64.8145C9.3516 63.9863 10.039 63.4781 10.9808 63.4781C11.6495 63.4781 12.1769 63.7135 12.5818 64.1934L12.045 64.8052C11.7531 64.5039 11.3669 64.3346 10.9619 64.3346C10.5759 64.3346 10.3309 64.4852 10.3309 64.7769C10.3309 65.0122 10.491 65.1345 10.9432 65.3227L11.3858 65.5015C12.2616 65.8686 12.6477 66.245 12.6477 66.8944C12.6477 67.3366 12.4877 67.6849 12.158 67.939C11.8283 68.1837 11.4234 68.3059 10.9337 68.3059C10.1426 68.3059 9.4834 67.9483 9.06902 67.412ZM16.5379 67.3649V68.2024C16.2271 68.2683 15.9541 68.3059 15.7186 68.3059C14.6544 68.3059 14.0141 67.779 14.0141 66.6967V64.4381H13.2606V63.5817H14.0141V62.3677H15.0123V63.5817H16.3872V64.4381H15.0123V66.612C15.0123 67.2049 15.3231 67.412 15.9258 67.412C16.0671 67.412 16.2649 67.3931 16.5379 67.3649ZM17.1565 65.8874C17.1282 64.5604 18.2677 63.4594 19.5956 63.4781C20.9423 63.45 22.0819 64.5793 22.0536 65.8874C22.0819 67.1955 20.9423 68.3342 19.5956 68.3059C18.2677 68.3342 17.1282 67.1955 17.1565 65.8874ZM21.0365 65.8968C21.0365 65.0404 20.4055 64.3817 19.605 64.3817C18.7857 64.3817 18.1641 65.0404 18.1641 65.8968C18.1641 66.7532 18.7857 67.3931 19.5956 67.3931C20.4149 67.3931 21.0365 66.7344 21.0365 65.8968ZM19.2471 62.857L19.9911 60.8619H21.1966V61.0408L19.9818 62.857H19.2471ZM25.8336 63.5817V64.4569H25.5323C24.7506 64.4569 24.1761 64.918 24.1761 65.7368V68.2024H23.1872V63.5817H24.1101V64.1841C24.4398 63.77 24.9295 63.5346 25.4569 63.5346C25.5981 63.5346 25.7206 63.5535 25.8336 63.5817ZM26.7189 68.2024V63.5817H27.7077V68.2024H26.7189ZM26.5399 61.8595C26.5399 61.4925 26.8413 61.2008 27.218 61.2008C27.5853 61.2008 27.8867 61.4925 27.8867 61.8595C27.8867 62.2266 27.5853 62.5089 27.218 62.5089C26.8413 62.5089 26.5399 62.2266 26.5399 61.8595ZM28.8457 65.8874C28.8175 64.5604 29.9663 63.4594 31.2943 63.4781C32.1513 63.4781 32.8388 63.8828 33.2438 64.5511L32.5468 65.0969C32.2172 64.6263 31.8029 64.3911 31.3037 64.3911C30.475 64.3911 29.8534 65.0498 29.8534 65.8874C29.8534 66.7344 30.475 67.3931 31.3037 67.3931C31.7934 67.3931 32.2078 67.1579 32.5468 66.6967L33.2438 67.2331C32.8294 67.9013 32.1324 68.3059 31.2943 68.3059C29.9287 68.3059 28.8457 67.2331 28.8457 65.8874ZM33.9499 65.8874C33.9217 64.5604 35.0613 63.4594 36.3892 63.4781C37.7359 63.45 38.8755 64.5793 38.8471 65.8874C38.8755 67.1955 37.7359 68.3342 36.3892 68.3059C35.0613 68.3342 33.9217 67.1955 33.9499 65.8874ZM37.8301 65.8968C37.8301 65.0404 37.1991 64.3817 36.3986 64.3817C35.5793 64.3817 34.9577 65.0404 34.9577 65.8968C34.9577 66.7532 35.5793 67.3931 36.3892 67.3931C37.2085 67.3931 37.8301 66.7344 37.8301 65.8968ZM42.3095 65.0969C42.2719 63.3182 43.807 61.8595 45.5774 61.8877C46.717 61.8877 47.7058 62.4431 48.2427 63.3182L47.4892 63.8735C47.0466 63.1865 46.4062 62.8007 45.5869 62.8007C44.3155 62.8007 43.3455 63.7794 43.3455 65.0969C43.3455 66.4144 44.3155 67.3931 45.5869 67.3931C46.4062 67.3931 47.0466 67.0073 47.4892 66.3203L48.2427 66.8755C47.7153 67.7507 46.7358 68.3059 45.5774 68.3059C43.807 68.3342 42.2719 66.8755 42.3095 65.0969ZM49.3708 68.2024V61.1443H50.3597V68.2024H49.3708ZM51.7896 68.2024V63.5817H52.7785V68.2024H51.7896ZM51.9121 62.857L52.3735 60.8619H53.579V61.0408L52.6467 62.857H51.9121ZM58.2486 65.3134V68.2024H57.2597V65.4451C57.2597 64.8052 56.8548 64.3722 56.2521 64.3722C55.64 64.3722 55.1973 64.8145 55.1973 65.4451V68.2024H54.2084V63.5817H55.1314V64.0335C55.4798 63.6664 55.9413 63.4781 56.5158 63.4781C57.5988 63.4781 58.2486 64.2122 58.2486 65.3134ZM59.6254 68.2024V63.5817H60.6143V68.2024H59.6254ZM59.4464 61.8595C59.4464 61.4925 59.7478 61.2008 60.1245 61.2008C60.4918 61.2008 60.7932 61.4925 60.7932 61.8595C60.7932 62.2266 60.4918 62.5089 60.1245 62.5089C59.7478 62.5089 59.4464 62.2266 59.4464 61.8595ZM61.7522 65.8874C61.724 64.5604 62.873 63.4594 64.2009 63.4781C65.0578 63.4781 65.7453 63.8828 66.1503 64.5511L65.4534 65.0969C65.1238 64.6263 64.7094 64.3911 64.2103 64.3911C63.3815 64.3911 62.76 65.0498 62.76 65.8874C62.76 66.7344 63.3815 67.3931 64.2103 67.3931C64.7 67.3931 65.1143 67.1579 65.4534 66.6967L66.1503 67.2331C65.7359 67.9013 65.0391 68.3059 64.2009 68.3059C62.8352 68.3059 61.7522 67.2331 61.7522 65.8874ZM66.8566 65.8874C66.8283 64.5604 67.9678 63.4594 69.2957 63.4781C70.6424 63.45 71.782 64.5793 71.7537 65.8874C71.782 67.1955 70.6424 68.3342 69.2957 68.3059C67.9678 68.3342 66.8283 67.1955 66.8566 65.8874ZM70.7366 65.8968C70.7366 65.0404 70.1056 64.3817 69.3051 64.3817C68.4858 64.3817 67.8642 65.0404 67.8642 65.8968C67.8642 66.7532 68.4858 67.3931 69.2957 67.3931C70.115 67.3931 70.7366 66.7344 70.7366 65.8968ZM75.5928 68.2024V61.9912H76.591V68.2024H75.5928ZM82.087 65.3134V68.2024H81.0982V65.4451C81.0982 64.8052 80.6932 64.3722 80.0905 64.3722C79.4784 64.3722 79.0357 64.8145 79.0357 65.4451V68.2024H78.0468V63.5817H78.9697V64.0335C79.3183 63.6664 79.7797 63.4781 80.3542 63.4781C81.4371 63.4781 82.087 64.2122 82.087 65.3134ZM86.2137 67.3649V68.2024C85.903 68.2683 85.6299 68.3059 85.3944 68.3059C84.3303 68.3059 83.6898 67.779 83.6898 66.6967V64.4381H82.9364V63.5817H83.6898V62.3677H84.6881V63.5817H86.0631V64.4381H84.6881V66.612C84.6881 67.2049 84.9989 67.412 85.6016 67.412C85.7429 67.412 85.9406 67.3931 86.2137 67.3649ZM91.2868 66.2168H87.84C87.9623 66.9696 88.5557 67.4307 89.3467 67.4307C89.827 67.4307 90.2791 67.252 90.6935 66.8849L91.1644 67.5625C90.6369 68.0613 90.0248 68.3059 89.3185 68.3059C87.9058 68.3059 86.8322 67.2614 86.8322 65.8968C86.804 64.5698 87.9153 63.45 89.2243 63.4781C90.4486 63.4781 91.3621 64.3911 91.3621 65.5956C91.3621 65.7932 91.3339 66.0003 91.2868 66.2168ZM87.8587 65.4451H90.3732C90.3639 64.7393 89.8365 64.3158 89.1866 64.3158C88.5368 64.3158 88.0094 64.758 87.8587 65.4451ZM96.1209 63.5817H97.0346V67.7225C97.0346 69.1811 96.1209 70 94.7178 70C93.8042 70 93.0508 69.6423 92.4952 69.1248L93.0414 68.4377C93.5594 68.8518 94.0303 69.0965 94.6613 69.0965C95.4994 69.0965 96.0457 68.6448 96.0457 67.779V67.4496C95.6972 67.8731 95.1227 68.1083 94.4823 68.1083C93.1921 68.1083 92.2315 67.139 92.2315 65.7932C92.2315 64.4476 93.2015 63.4781 94.4823 63.4781C95.1886 63.4781 95.782 63.7605 96.1209 64.2405V63.5817ZM96.0551 65.7839C96.0551 64.8428 95.4241 64.3628 94.6613 64.3628C94.2563 64.3628 93.9267 64.4946 93.6535 64.758C93.3805 65.0215 93.2486 65.3698 93.2486 65.7932C93.2486 66.2262 93.3805 66.5744 93.6535 66.8473C93.9267 67.1108 94.2563 67.2425 94.6613 67.2425C95.0474 67.2425 95.3676 67.1203 95.6407 66.8661C95.9138 66.612 96.0551 66.2544 96.0551 65.7839ZM101.11 63.5817V64.4569H100.809C100.027 64.4569 99.4529 64.918 99.4529 65.7368V68.2024H98.464V63.5817H99.3869V64.1841C99.7165 63.77 100.206 63.5346 100.734 63.5346C100.875 63.5346 100.997 63.5535 101.11 63.5817ZM105.576 65.4074V68.2024H104.654V67.6849C104.315 68.0896 103.806 68.3059 103.175 68.3059C102.205 68.3059 101.565 67.7696 101.565 66.9696C101.565 66.1697 102.224 65.6521 103.269 65.6521H104.578V65.351C104.578 64.711 104.22 64.3628 103.589 64.3628C103.071 64.3628 102.695 64.5887 102.309 65.0498L101.734 64.4663C102.196 63.7981 102.883 63.4781 103.684 63.4781C104.823 63.4781 105.576 64.1652 105.576 65.4074ZM104.578 66.4521V66.3673H103.392C102.864 66.3673 102.572 66.5556 102.572 66.932C102.572 67.3179 102.902 67.5437 103.382 67.5437C104.051 67.5437 104.578 67.0825 104.578 66.4521ZM110.465 61.1443H111.464V68.2024H110.541V67.5437C110.202 68.0237 109.608 68.3059 108.921 68.3059C107.621 68.3059 106.661 67.2614 106.661 65.8968C106.633 64.5511 107.64 63.45 108.921 63.4781C109.562 63.4781 110.117 63.7229 110.465 64.1463V61.1443ZM110.484 65.8968C110.484 64.8993 109.806 64.3817 109.091 64.3817C108.299 64.3817 107.668 65.0028 107.668 65.8874C107.668 66.772 108.271 67.4025 109.091 67.4025C109.816 67.4025 110.484 66.9038 110.484 65.8968ZM112.602 65.8874C112.574 64.5604 113.713 63.4594 115.041 63.4781C116.388 63.45 117.527 64.5793 117.499 65.8874C117.527 67.1955 116.388 68.3342 115.041 68.3059C113.713 68.3342 112.574 67.1955 112.602 65.8874ZM116.482 65.8968C116.482 65.0404 115.851 64.3817 115.05 64.3817C114.232 64.3817 113.61 65.0404 113.61 65.8968C113.61 66.7532 114.232 67.3931 115.041 67.3931C115.861 67.3931 116.482 66.7344 116.482 65.8968Z'
							fill='white'
						/>
					</svg>
				);
			case 3:
				return (
					<img
						alt='Memória de Cálculo'
						src={CalculoPNG}
					/>
				);
			case 4:
				return (
					<img
						alt='Contatos'
						src={ContatosPNG}
					/>
				);
			case 5:
				return (
					<img
						alt='Agenda Interna SUBHUE'
						src={CalendarioPNG}
					/>
				);
			case 6:
				return (
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='140'
						viewBox='0 0 90 74'
						fill='none'>
						<path
							d='M41.5275 46.4804C41.7841 48.0559 42.4542 49.5006 43.4027 50.7013C41.6633 52.9008 40.8553 55.9185 41.8241 59.0418L41.825 59.0447C42.4507 61.0535 43.298 63.0231 44.3995 64.9183C45.4981 66.8087 46.7854 68.5275 48.2286 70.0732C48.5422 70.4093 48.8717 70.714 49.2142 70.9884L4.63499 71C4.63484 71 4.63469 71 4.63454 71C3.65544 70.9998 2.8808 70.212 2.8808 69.2654C2.8808 56.6131 13.181 46.3438 25.9202 46.3438H39.0123C39.858 46.3438 40.6987 46.3913 41.5275 46.4804ZM32.4663 3C36.6696 3 40.6984 4.66216 43.6671 7.61715C46.6353 10.5717 48.3008 14.5766 48.3008 18.75C48.3008 22.9234 46.6353 26.9283 43.6671 29.8829C40.6984 32.8378 36.6696 34.5 32.4663 34.5C28.263 34.5 24.2341 32.8378 21.2654 29.8829C18.2972 26.9283 16.6317 22.9234 16.6317 18.75C16.6317 14.5766 18.2972 10.5717 21.2654 7.61715C24.2341 4.66216 28.263 3 32.4663 3Z'
							stroke='white'
							strokeWidth='5'
						/>
						<path
							d='M63.6368 33.794C63.6368 32.9008 64.211 32.0969 65.0787 31.9055C66.4185 31.5992 67.8222 31.4333 69.2514 31.4333C70.6805 31.4333 72.0842 31.5992 73.424 31.9055C74.2917 32.0969 74.8659 32.9008 74.8659 33.794V37.6987C75.874 38.1326 76.831 38.6813 77.7115 39.332L80.8889 37.5073C81.6672 37.0607 82.637 37.1628 83.2495 37.8135C84.2193 38.8471 85.0743 40.0083 85.8144 41.2844C86.5545 42.5604 87.1287 43.8875 87.537 45.2401C87.805 46.0951 87.3967 46.9883 86.6183 47.4349L83.4282 49.2724C83.4792 49.7828 83.5175 50.306 83.5175 50.8419C83.5175 51.3779 83.492 51.8883 83.4282 52.4115L86.6183 54.249C87.3967 54.6956 87.7922 55.5888 87.537 56.4438C87.1159 57.7964 86.5417 59.1234 85.8144 60.3995C85.087 61.6755 84.2193 62.8367 83.2495 63.8703C82.637 64.5211 81.6545 64.6232 80.8889 64.1766L77.7115 62.3518C76.831 63.0026 75.8868 63.5513 74.8659 63.9852V67.8898C74.8659 68.7831 74.2917 69.587 73.424 69.7784C72.0842 70.0846 70.6805 70.2505 69.2514 70.2505C67.8222 70.2505 66.4185 70.0846 65.0787 69.7784C64.211 69.587 63.6368 68.7831 63.6368 67.8898V63.9979C62.6159 63.5641 61.6461 63.0154 60.7657 62.3518L57.6139 64.1766C56.8355 64.6232 55.8657 64.5211 55.2532 63.8703C54.2834 62.8367 53.4284 61.6755 52.6883 60.3995C51.9482 59.1234 51.374 57.7964 50.9657 56.4438C50.6977 55.5888 51.106 54.6956 51.8844 54.249L55.049 52.4242C54.998 51.901 54.9597 51.3779 54.9597 50.8419C54.9597 50.306 54.9852 49.7828 55.049 49.2596L51.8717 47.4221C51.0933 46.9755 50.6977 46.0823 50.9529 45.2273C51.374 43.8747 51.9355 42.5477 52.6756 41.2716C53.4157 39.9956 54.2706 38.8344 55.2404 37.8008C55.8529 37.15 56.8227 37.0479 57.6011 37.4945L60.7657 39.3193C61.6461 38.6685 62.6159 38.1198 63.6368 37.6732V33.7813V33.794ZM75.3891 50.8292C75.4269 50.0005 75.2964 49.1727 75.0053 48.3958C74.7142 47.619 74.2687 46.9092 73.6956 46.3094C73.1225 45.7096 72.4338 45.2322 71.671 44.906C70.9083 44.5798 70.0873 44.4116 69.2577 44.4116C68.4282 44.4116 67.6072 44.5798 66.8444 44.906C66.0817 45.2322 65.3929 45.7096 64.8199 46.3094C64.2468 46.9092 63.8013 47.619 63.5102 48.3958C63.2191 49.1727 63.0885 50.0005 63.1264 50.8292C63.0885 51.6579 63.2191 52.4857 63.5102 53.2625C63.8013 54.0393 64.2468 54.7491 64.8199 55.3489C65.3929 55.9488 66.0817 56.4262 66.8444 56.7524C67.6072 57.0785 68.4282 57.2467 69.2577 57.2467C70.0873 57.2467 70.9083 57.0785 71.671 56.7524C72.4338 56.4262 73.1225 55.9488 73.6956 55.3489C74.2687 54.7491 74.7142 54.0393 75.0053 53.2625C75.2964 52.4857 75.4269 51.6579 75.3891 50.8292Z'
							stroke='#00C0F3'
							strokeWidth='4'
						/>
					</svg>
				);
			case 7:
				return (
					<img
						alt='Visualizador de Escalas'
						className='w-[30px] h-[30px]'
						src={EscalaPNG}
					/>
				);
			case 8:
				return (
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='110'
						height='120'
						viewBox='0 0 74 78'
						fill='none'>
						<path
							d='M4 26.1053V62.9474C4 64.9016 4.77631 66.7758 6.15816 68.1576C7.54001 69.5395 9.41419 70.3158 11.3684 70.3158H33.4737M4 26.1053V18.7368C4 16.7826 4.77631 14.9084 6.15816 13.5266C7.54001 12.1447 9.41419 11.3684 11.3684 11.3684H18.7368M4 26.1053H62.9474M18.7368 11.3684H48.2105M18.7368 11.3684V4M62.9474 26.1053V18.7368C62.9474 16.7826 62.1711 14.9084 60.7892 13.5266C59.4074 12.1447 57.5332 11.3684 55.5789 11.3684H48.2105M62.9474 26.1053V37.1579M48.2105 11.3684V4'
							stroke='white'
							strokeWidth='7.36842'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
						<path
							d='M59.0526 52V63.0526M59.0526 63.0526V74.1053M59.0526 63.0526H70.1053M59.0526 63.0526H48'
							stroke='#00C0F3'
							strokeWidth='7.36842'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</svg>
				);
			case 9:
				return (
					<img
						alt='Monitoramento de Leitos'
						className='w-[155px] h-[140px]'
						src={Monitoramento}
					/>
				);
			case 10:
				return (
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='100'
						height='110'
						viewBox='0 0 96 99'
						fill='none'>
						<path
							d='M63.9963 91.5574C62.8247 92.729 60.9252 92.729 59.7537 91.5574L42.9588 74.7626C41.7872 73.591 41.7872 71.6915 42.9588 70.5199L45.6462 67.8326C46.8177 66.661 48.7172 66.661 49.8888 67.8326L61.875 79.8187L87.7212 53.9726C88.8927 52.801 90.7922 52.801 91.9638 53.9726L94.6512 56.6599C95.8227 57.8315 95.8227 59.731 94.6512 60.9026L63.9963 91.5574ZM89.1 41.55C89.1 43.2069 87.7569 44.55 86.1 44.55H82.2C80.5431 44.55 79.2 43.2069 79.2 41.55V22.8C79.2 21.1431 77.8568 19.8 76.2 19.8H72.3C70.6431 19.8 69.3 21.1431 69.3 22.8V31.65C69.3 33.3069 67.9568 34.65 66.3 34.65H22.8C21.1431 34.65 19.8 33.3069 19.8 31.65V22.8C19.8 21.1431 18.4569 19.8 16.8 19.8H12.9C11.2431 19.8 9.9 21.1431 9.9 22.8V86.1C9.9 87.7569 11.2431 89.1 12.9 89.1H36.6C38.2569 89.1 39.6 90.4431 39.6 92.1V96C39.6 97.6569 38.2569 99 36.6 99H9.9C7.1775 99 4.8477 98.0314 2.9106 96.0943C0.9735 94.1572 0.0033 91.8258 0 89.1V19.8C0 17.0775 0.9702 14.7477 2.9106 12.8106C4.851 10.8735 7.1808 9.9033 9.9 9.9H30.5662C31.4737 7.0125 33.2475 4.64145 35.8875 2.78685C38.5275 0.93225 41.415 0.0033 44.55 0C47.85 0 50.8002 0.92895 53.4006 2.78685C56.001 4.64475 57.7533 7.0158 58.6575 9.9H79.2C81.9225 9.9 84.2539 10.8702 86.1943 12.8106C88.1347 14.751 89.1033 17.0808 89.1 19.8V41.55ZM44.55 19.8C45.9525 19.8 47.1289 19.3248 48.0793 18.3744C49.0298 17.424 49.5033 16.2492 49.5 14.85C49.4967 13.4508 49.0215 12.276 48.0744 11.3256C47.1273 10.3752 45.9525 9.9 44.55 9.9C43.1475 9.9 41.9727 10.3752 41.0256 11.3256C40.0785 12.276 39.6033 13.4508 39.6 14.85C39.5967 16.2492 40.0719 17.4256 41.0256 18.3793C41.9793 19.333 43.1541 19.8066 44.55 19.8Z'
							fill='white'
						/>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='97'
							height='99'
							viewBox='0 0 97 99'
							fill='none'>
							<path
								d='M63.9963 91.5574C62.8247 92.729 60.9252 92.729 59.7537 91.5574L42.9588 74.7626C41.7872 73.591 41.7872 71.6915 42.9588 70.5199L45.6462 67.8326C46.8177 66.661 48.7172 66.661 49.8888 67.8326L61.875 79.8187L87.7212 53.9726C88.8927 52.801 90.7922 52.801 91.9638 53.9726L94.6512 56.6599C95.8227 57.8315 95.8227 59.731 94.6512 60.9026L63.9963 91.5574ZM89.1 41.55C89.1 43.2069 87.7569 44.55 86.1 44.55H82.2C80.5431 44.55 79.2 43.2069 79.2 41.55V22.8C79.2 21.1431 77.8568 19.8 76.2 19.8H72.3C70.6431 19.8 69.3 21.1431 69.3 22.8V31.65C69.3 33.3069 67.9568 34.65 66.3 34.65H22.8C21.1431 34.65 19.8 33.3069 19.8 31.65V22.8C19.8 21.1431 18.4569 19.8 16.8 19.8H12.9C11.2431 19.8 9.9 21.1431 9.9 22.8V86.1C9.9 87.7569 11.2431 89.1 12.9 89.1H36.6C38.2569 89.1 39.6 90.4431 39.6 92.1V96C39.6 97.6569 38.2569 99 36.6 99H9.9C7.1775 99 4.8477 98.0314 2.9106 96.0943C0.9735 94.1572 0.0033 91.8258 0 89.1V19.8C0 17.0775 0.9702 14.7477 2.9106 12.8106C4.851 10.8735 7.1808 9.9033 9.9 9.9H30.5662C31.4737 7.0125 33.2475 4.64145 35.8875 2.78685C38.5275 0.93225 41.415 0.0033 44.55 0C47.85 0 50.8002 0.92895 53.4006 2.78685C56.001 4.64475 57.7533 7.0158 58.6575 9.9H79.2C81.9225 9.9 84.2539 10.8702 86.1943 12.8106C88.1347 14.751 89.1033 17.0808 89.1 19.8V41.55ZM44.55 19.8C45.9525 19.8 47.1289 19.3248 48.0793 18.3744C49.0298 17.424 49.5033 16.2492 49.5 14.85C49.4967 13.4508 49.0215 12.276 48.0744 11.3256C47.1273 10.3752 45.9525 9.9 44.55 9.9C43.1475 9.9 41.9727 10.3752 41.0256 11.3256C40.0785 12.276 39.6033 13.4508 39.6 14.85C39.5967 16.2492 40.0719 17.4256 41.0256 18.3793C41.9793 19.333 43.1541 19.8066 44.55 19.8Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M40.8375 72.6412L61.875 93.6787L96.7725 58.7812L89.8425 51.8512L61.875 79.8187L47.7675 65.7112L40.8375 72.6412Z'
								fill='#00C0F3'
							/>
						</svg>
					</svg>
				);
			default:
				return null;
		}
	};

	const getLink = (index) => {
		switch (index) {
			case 0:
				return '/escala';
			case 1:
				return 'paineis-de-monitoramento';
			case 2:
				return 'https://hci.rio.gov.br/auth/sign-in';
			case 3:
				return '/hub';
			case 4:
				return '/hub';
			case 5:
				return '/calendario-interno';
			case 6:
				return '/permissionador';
			case 7:
				return '/admin-visualize';
			case 8:
				return '/calendar-form';
			case 9:
				return '/monitoramento-leitos';
			case 10:
				return '/notes-avaliation';
			default:
				return '/';
		}
	};

	const getCardName = (index) => {
		switch (index) {
			case 0:
				return 'Escala de Profissionais';
			case 1:
				return 'Painéis de Monitoramento';
			case 2:
				return 'Histórico Clínico Integrado';
			case 3:
				return 'Memória de Cálculo';
			case 4:
				return 'Contatos';
			case 5:
				return 'Agenda Interna SUBHUE';
			case 6:
				return 'Permissões de Usuários';
			case 7:
				return 'Visualizador de Escalas';
			case 8:
				return 'Adicione novo evento SUBHUE';
			case 9:
				return 'Monitoramento de Leitos';
			case 10:
				return 'Notificações de Incidentes';
			default:
				return '';
		}
	};

	return (
		<div className='flex items-center mt-[8%] mb-[5%] md:mt-[2%] w-100 xl:mb-[3%] 2xl:mb-[10%]'>
			<div className='flex flex-col md:flex-row md:flex-wrap gap-10 md:gap-[36px] justify-center items-center w-full'>
				{visibleCards.map((index) => (
					<a
						key={index}
						rel='noopener noreferrer'
						target={index === 2 ? '_blank' : '_self'}
						href={getLink(index)}
						className='flex flex-row md:scale-100 justify-center w-[250px] h-[200px] md:w-[200px] md:h-[240px] hover:no-underline hover:scale-11 cursor-pointer rounded-sm transform transition duration-300 hover:scale-110'>
						<div className='hover:no-underline flex flex-col items-center justify-between g transform transition duration-300 hover:scale-105 md:h-[240px] md:w-[105%] w-[80%] bg-[#F5F5F5] rounded-md shadow-md'>
							<div className='flex justify-start bg-[#004A80] w-full mb-[7px] rounded-t-md h-[128px]'>
								<div className='flex justify-center w-full md:scale-[55%] scale-[48%]'>
									{getSVG(index)}
								</div>
							</div>
							<div className='h-[2px] w-[80%] bg-[#D9D9D9]'></div>
							<p className='font-semibold mx-1 my-auto px-1 text-[#757575]'>
								{getCardName(index)}
							</p>
						</div>
					</a>
				))}
			</div>
		</div>
	);
}

export default ICards;
